import type DbModule from '../db';
import UpvoteService, { type TipCommentApiRequestPayload, type DeleteUserContentApiRequestPayload } from './upvote.service';
import type AccountModule from '../account';
import {} from '../account';
import type StorageModule from '../storage';
import type TokenModule from '../token';
import type AppCheckModule from '../app-check';
import type { FirebaseApp } from 'firebase/app';

export interface LinkMeta {
    url: string;
    title?: string;
    site_name?: string;
    description?: string;
    image?: {
        url: string;
        width?: string | null;
        height?: string | null;
    };

    twitterUrl?: string;
    twitterPlayer?: string;
    videoWidth?: string;
    videoHeight?: string;
    trackId?: string;
}

export type DeleteUserContentPayload = DeleteUserContentApiRequestPayload;
export type TipCommentPayload = TipCommentApiRequestPayload;

export default class UpvoteModule {
    accountModule: AccountModule;
    tokenModule: TokenModule;
    upvoteService: UpvoteService;
    domainName: string;
    private dbModule: DbModule;
    private storageModule: StorageModule;
    private appCheckModule: AppCheckModule;
    constructor(
        app: FirebaseApp,
        contractName: string,
        domainName: string,
        appCheckModule: AppCheckModule,
        dbModule: DbModule,
        storageModule: StorageModule,
        accountModule: AccountModule,
        tokenModule: TokenModule,
    ) {
        this.dbModule = dbModule;
        this.storageModule = storageModule;
        this.domainName = domainName;
        this.upvoteService = new UpvoteService(contractName, domainName, appCheckModule, dbModule, accountModule);
        this.accountModule = accountModule;
        this.tokenModule = tokenModule;
        this.appCheckModule = appCheckModule;
    }

    async deleteUserContent(payload: DeleteUserContentPayload): Promise<string> {
        const res = await this.upvoteService.deleteUserContent(payload);
        return res.payload;
    }

    // async tipComment(payload: TipCommentPayload) {
    //     const { userId, commentId, tokenName, amount } = payload;

    //     const data: TipCommentApiRequestPayload = {
    //         commentId,
    //         tokenName,
    //         amount,
    //         userId,
    //     };

    //     const res = await this.upvoteService.tipComment(data);
    //     return res.payload;
    // }
}
